import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { geoComparisonReason, geoComparisonCityFact } = useReportFiltersFetch({ fetchGeoComparisonReason: true, fetchGeoComparisonCityFact: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        id="reason"
                        label="Natureza *"
                        isMulti={false}
                        wrapValues={true}
                        options={geoComparisonReason}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({ ...prev, reason: value }))}
                        classNameWrapper="w-full"
                    />

                    <SelectComponent
                        id="cityFact"
                        label="Município do fato"
                        isMulti={false}
                        wrapValues={true}
                        options={geoComparisonCityFact}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
                        classNameWrapper="w-full"
                    />

                    <InputCheckbox
                        id="animationMode"
                        label="Modo animação"
                        className={'ml-1 mb-4'}
                        checked={filters.animationMode}
                        onChange={(e) => setFilters(prev => ({...prev, animationMode: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="onlyMyCity"
                        label="Apenas ocorrências da minha corporação"
                        className={'ml-1 mb-4'}
                        checked={filters.onlyMyCity}
                        onChange={(e) => setFilters(prev => ({...prev, onlyMyCity: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className={'ml-1'}
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({...prev, archivedOccurrences: e.target.checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;